import React, { useEffect, useState } from 'react';
import { filter, Subject, takeUntil } from 'rxjs';

import useStyles from 'isomorphic-style-loader/useStyles';
import {
	Container, DataService, XpSourceType, i18n,
} from '../../../../../symphony';

import {
	ActionType,
	IMaterialProps,
	IWidgetData,
	RequestType,
} from '../../../global-interface';
import { Widget } from '../../Widget/Widget';
import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';
import { SlActions } from '../../../services/ActionsService/sl-actions';

import s from './CodeProject.scss';

export function CodeProject({ materialInfo }: IMaterialProps): JSX.Element {
	useStyles(s);
	const {
		header: {
			title, description, typeId, id, materialRelationId,
		},
		status,
		options,
	} = materialInfo;
	const { xpSourcesList$ } = Container.take('global', DataService);

	const [isCurrentCP, setIsCurrentCP] = useState<boolean>(false);

	const xp = xpSourcesList$.value?.xpSources.find(
		(item) => item.xpSource === XpSourceType.EOMSolve,
	)?.xp;

	useEffect(() => {
		const { currentItems$ } = Container.take(SlLEContext, SlDataService);

		const unsubscriber = new Subject<void>();

		currentItems$
			.pipe(
				takeUntil(unsubscriber),
				filter((i) => !!i),
			)
			.subscribe((items) => setIsCurrentCP(
				items.some(({ materialId }) => materialId === materialRelationId),
			));

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const onPracticeClickHandler = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.onCPPracticeClick,
			requestType: RequestType.Parallel,
			data: {
				materialInfo,
			},
		});
	};

	const widgetData: IWidgetData = {
		status,
		title,
		description,
		type: typeId,
		xp,
		button: {
			title: i18n.t('web-le.material-type-practice'),
			onClick: onPracticeClickHandler,
		},
		isCurrent: isCurrentCP,
	};

	return (
		<div
			sl-test-data="cmpCodeProject"
			className="le-code-project"
			le-data-id={materialRelationId}
		>
			<Widget
				parentType={options.parentType}
				widget={widgetData}
				onClick={onPracticeClickHandler}
				id={id}
			/>
		</div>
	);
}
